var _this = this;
import Vue from "vue";
import store from "../store";
import GlobalVue from "../globalVue";
import MyService from "@/page/service/MyService.vue";
import MessageDialog from "@/components/login/MessageDialog.vue";
import { Draggable } from 'draggable-vue-directive';
Vue.directive("focus", {
    inserted: function (el) {
        el.focus();
    }
});
Vue.directive("show-focus", {
    update: function (el, binding) {
        if (binding.value) {
            el.focus();
        }
    }
});
Vue.directive("position", {
    inserted: function (el, binding) {
        setTimeout(function () {
            binding.value.frontPosition = {
                x: el.offsetLeft,
                y: el.offsetTop
            };
        }, 100);
    }
});
Vue.directive("show-parent", {
    inserted: function (el, binding) {
        var parentNode = binding.value.parentNode;
        var className = "parent-value-label-" + parentNode.id;
        var parentContainerClass = 'parent-container';
        var parentElement = el.parentElement;
        while (parentElement && !parentElement.classList.contains('vue-treeselect__multi-value')) {
            parentElement = parentElement.parentElement;
        }
        var parentLabel = parentElement ? parentElement.querySelector("." + className) : null;
        if (!parentLabel) {
            var parentContainer = parentElement.querySelector("." + parentContainerClass);
            if (!parentContainer) {
                parentContainer = document.createElement("div");
                parentContainer.classList.add(parentContainerClass);
                parentContainer.style.cssText = "position:absolute;left:0; line-height:32px;top:0;";
                parentElement.appendChild(parentContainer);
            }
            parentLabel = document.createElement("span");
            parentLabel.classList.add(className);
            parentLabel.style.cssText = "margin-right:10px; padding:3px; border:1px solid #eee";
            parentLabel.innerHTML = parentNode.label;
            parentContainer.appendChild(parentLabel);
        }
        el.classList.add('child-value-label-' + binding.value.raw.tempId);
        el.parentElement.parentElement.parentElement.style.display = 'none';
    },
    unbind: function (el, binding) {
        var parentElement = el.parentElement;
        while (parentElement && !parentElement.classList.contains('vue-treeselect__multi-value')) {
            parentElement = parentElement.parentElement;
        }
        var parentNode = binding.value.parentNode;
        var className = "parent-value-label-" + parentNode.id;
        setTimeout(function () {
            if (parentElement) {
                var allChildRemove = (parentNode.children || []).every(function (item) { return !parentElement.querySelector("." + 'child-value-label-' + item.raw.tempId); });
                if (allChildRemove) {
                    var parentNodeEl = parentElement.querySelector("." + className);
                    parentNodeEl && (parentNodeEl.remove());
                }
            }
        }, 300);
    }
});
Vue.directive("canOpenPage", {
    inserted: function (el, binding, vnode) {
        function addTabService(service_status) {
            store.dispatch('updateHomeShow', false);
            GlobalVue.$emit("addTab", {
                component: MyService,
                title: "会员服务",
                name: "service",
                showExist: true,
                cprops: {
                    service_status: service_status
                }
            });
        }
        binding.value.list && binding.value.list.forEach(function (item) {
            if (item.power_key.indexOf(binding.value.power_code) != -1) {
                el.addEventListener('click', function () {
                    var instance = Vue.prototype.$dialog(MessageDialog, {
                        data: {
                            msg: item.msg,
                            service_status: item.service_status
                        }
                    }, {
                        title: "提示",
                        width: 420,
                        height: 250,
                        zIndex: 100000
                    }).instance;
                    instance.$on('openService', function (service_status) {
                        addTabService(service_status);
                    });
                    instance.$on('payService', function (service_status) {
                        addTabService(service_status);
                    });
                }, false);
            }
        });
    }
});
Vue.directive('drag', Draggable);
function fucosInput(event, binding) {
    var inputIndex = binding.value.index;
    var prefix = binding.value.prefix;
    console.log('focus-on-arrow', event.key, inputIndex, prefix);
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
        event.stopPropagation();
        var step = event.key === 'ArrowUp' ? -1 : 1;
        var nextIndex = inputIndex + step;
        var parentsTable = $(event.target).parents('table');
        var nextInput = parentsTable && parentsTable.find("#" + prefix + nextIndex);
        if (nextInput) {
            $(nextInput).focus();
            $(nextInput).find('input') && $(nextInput).find('input').focus();
        }
    }
}
Vue.directive('focus-on-arrow', {
    inserted: function (el, binding, vnode) {
        el.addEventListener('keydown', function (event) { fucosInput.call(this, event, binding); }.bind(_this));
    },
    unbind: function (el, binding, vnode) {
        el.removeEventListener('keydown', function (event) { fucosInput.call(this, event, binding); }.bind(_this));
    }
});
